import { Injectable } from '@angular/core';
import {WorkflowsStoreFacadeService} from "@well/iriro-frontend-libs/workflows/store";

@Injectable({
  providedIn: 'root'
})
export class WorkflowsStoreApiService {

  constructor(private workflowsFacade: WorkflowsStoreFacadeService) { }

  fetchAllConfigurations() {
    return this.workflowsFacade.fetchAllConfigurations();
  }

  clearAllConfigurations() {
    return this.workflowsFacade.clearAllConfigurations();
  }
  getWorkflowsStep(workflowName: string, stepId: string) {
    return this.workflowsFacade.stepConfiguration$(workflowName, stepId);
  }
}
